/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Signals_NoteInputs */

const en_directory_builders_signals_note = /** @type {(inputs: Directory_Builders_Signals_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identity verification, follows, and activity history remain UI decisions until their operating rules are finalized.`)
};

const zh_directory_builders_signals_note = /** @type {(inputs: Directory_Builders_Signals_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份验证、关注关系和活动历史仍属于 UI 决策，需在运营规则确定后接入。`)
};

/**
* | output |
* | --- |
* | "Identity verification, follows, and activity history remain UI decisions until their operating rules are finalized." |
*
* @param {Directory_Builders_Signals_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_signals_note = /** @type {((inputs?: Directory_Builders_Signals_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Signals_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_signals_note(inputs)
	return zh_directory_builders_signals_note(inputs)
});
export { directory_builders_signals_note as "directory.builders.signals_note" }